import styled from "styled-components";

export const GlobalPrmModeWrapper = styled.div`
    display: grid;
    height: 100%;
    grid-template-rows: 1002px auto;
`;
